// src/store/api/axiosPublic.js
import axios from "axios";

export const baseURLNew = "https://stageapilead.blaccdot.com/api/";

const axiosPublic = axios.create({
  baseURL: baseURLNew,
});

export default axiosPublic;
